import Text from '@components/Text';
import s from '@modules/static/components/StaticContract/StaticContract.module.scss';

const ContractSign = ({ fio = '________________', sign = '_______________' }: { fio?: string; sign?: string }) => (
  <Text className={s.contractRequisitesSign} fontgraphik>
    <Text>
      {fio}
      {' /'}
    </Text>
    <span>
      <Text className={s.contractRequisitesSignSpaceLine}>
        {sign}
        {'/'}
      </Text>
      <Text size="small" className={s.contractRequisitesSignSpaceLabel}>
        (подпись)
      </Text>
    </span>
  </Text>
);

export default ContractSign;
